import React, { type ReactNode, type JSX } from 'react';

type WarningParagraphProps = {
  children: ReactNode;
  className?: string;
  showCopyButton?: boolean;
  style?: 'orange' | 'red';
};

export default function WarningParagraph({
  children,
  style = 'orange',
  className,
}: WarningParagraphProps): JSX.Element {
  return (
    <p
      className={`warning-paragraph warning-paragraph--${style} ${
        className ?? ''
      }`}
    >
      <span className='warning-paragraph__inset'></span>
      <span>{children}</span>
    </p>
  );
}
